import { render, staticRenderFns } from "./ticketing.vue?vue&type=template&id=fa3b450e&scoped=true"
import script from "./ticketing.vue?vue&type=script&lang=js"
export * from "./ticketing.vue?vue&type=script&lang=js"
import style0 from "./ticketing.vue?vue&type=style&index=0&id=fa3b450e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3b450e",
  null
  
)

export default component.exports